/* eslint-disable react-hooks/exhaustive-deps */
import "./MembershipScreen.css";
import rightArrow from "../../assets/images/membership-card-button-icon.svg";
import appIcon from "../../assets/images/header-sabehub-app-icon.svg";
import rightOrangeIcon from "../../assets/images/dashboard-right-orenge.svg";
import infoIcon from "../../assets/images/dashboard-info-icon.svg";
import activeTagIcon from "../../assets/images/membership-active-tag.svg";
import paymentHistoryIcon from "../../assets/images/payment-history-icon.svg";
import { useNavigate } from "react-router-dom";
import ROUTE_PATHS from "utils/routePaths";
import {
  CALENDAR_RESERVATION_TABS,
  MEMBERSHIP_FOUNDER_TYPE,
  MEMBERSHIP_FOUNDER_TYPES,
  MEMBERSHIP_TYPE,
} from "utils/constants";
import {
  getIsActiveMemberStatus,
  getMembershipCardImage,
  getMembershipPassesIcon,
  highlightLastWord,
} from "utils/utils";
import { useEffect, useState } from "react";
import MembershipInviteOnlyDialog from "components/elements/MembershipInviteOnlyDialog";
import { useStorage } from "services/StorageProvider";
import CreditPlanDialog from "components/elements/CreditPlanDialog";
import { useQuery } from "@tanstack/react-query";
import useWSMApi from "services/api/useWSMApi";
import { WEB_LINK } from "utils/strings";

const MembershipScreen = () => {
  const navigate = useNavigate();
  const {
    creditPlanListData,
    userProfileData,
    refreshUserProfile,
    refreshAppData,
  } = useStorage();
  const { fetchPasses, fetchMembershipByType } = useWSMApi();
  const [showInviteOnlyDialog, setShowInviteOnlyDialog] =
    useState<boolean>(false);
  const [showCreditPlanDialog, setShowCreditPlanDialog] =
    useState<boolean>(false);
  const [selectedCreditPlan, setSelectedCreditPlan] = useState<any>(null);
  const isActiveMember = getIsActiveMemberStatus(userProfileData);
  const [selectedTab, setSelectedTab] = useState<string>(() => {
    const storedTab = sessionStorage.getItem("membershipSelectedTab");
    return storedTab ?? MEMBERSHIP_FOUNDER_TYPE.SABEHUB;
  });

  useEffect(() => {
    refreshUserProfile();
    refreshAppData();
  }, []);

  useEffect(() => {
    sessionStorage.setItem("membershipSelectedTab", selectedTab);
  }, [selectedTab]);

  const { data: passesData } = useQuery({
    queryKey: ["get-passes", selectedTab],
    queryFn: () =>
      fetchPasses({
        type: selectedTab,
      }),
    retry: false,
  });

  const { data: membershipData } = useQuery({
    queryKey: ["get-membership", selectedTab],
    queryFn: () =>
      fetchMembershipByType({
        type: getMembershipType(),
      }),
    retry: false,
  });

  const getMembershipType = () => {
    if (selectedTab === MEMBERSHIP_FOUNDER_TYPE.SABEHUB) {
      return "FOUNDRY";
    } else if (selectedTab === MEMBERSHIP_FOUNDER_TYPE.EXECUTION) {
      return "WORKSPACE";
    } else {
      return "WELLNESS";
    }
  };

  const approvedMembership = membershipData?.data?.content?.find(
    (membership: any) =>
      membership.id === userProfileData?.credit?.approved_membership,
  );

  const filteredMembershipList = !isActiveMember
    ? membershipData?.data?.content?.filter(
        (membership: any) =>
          membership.id !== userProfileData?.credit?.approved_membership,
      )
    : membershipData?.data?.content;

  const handleURMembershipCardClick = () => {
    navigate(ROUTE_PATHS.WSM_UR_MEMBERSHIP_PLAN_DETAIL);
  };

  const handleMembershipCardClick = (data: any) => {
    if (
      data?.membership_level === 3 &&
      data?.id !== userProfileData?.credit?.approved_membership
    ) {
      setShowInviteOnlyDialog(true);
    } else {
      localStorage.setItem("selectedMembershipData", JSON.stringify(data));
      navigate(ROUTE_PATHS.WSM_MEMBERSHIP_PLAN_DETAIL);
    }
  };

  const handleCreditPlanCardClick = (data: any) => {
    setSelectedCreditPlan(data);
    setShowCreditPlanDialog(true);
  };

  const handlePassCardClick = (data: any) => {
    localStorage.setItem("selectedPassData", JSON.stringify(data));
    navigate(ROUTE_PATHS.WSM_MEMBERSHIP_PASS_DETAIL);
  };

  // const handleFullDayPassClick = (data: any) => {
  //   localStorage.setItem("selectedFullDayPassData", JSON.stringify(data));
  //   navigate(ROUTE_PATHS.WSM_MEMBERSHIP_ONE_DAY_PASS_DETAIL);
  // };

  const handlePaymentHistoryClick = () => {
    navigate(ROUTE_PATHS.WSM_PAYMENT_HISTORY);
  };

  return (
    <div className="wms-mobile-container">
      <header className="membership-screen-header-header-bar">
        <div className="membership-screen-header-left-container">
          <img src={appIcon} alt="logo" className="header-image" />
        </div>
        <div className="membership-screen-header-divider"></div>
        <div className="membership-screen-header-right-container">
          <span>Memberships</span>
          <img
            src={paymentHistoryIcon}
            alt="left-button"
            onClick={handlePaymentHistoryClick}
          />
        </div>
      </header>

      {userProfileData?.credit?.membership_end_date &&
        new Date(userProfileData.credit.membership_end_date) > new Date() && (
          <div className="membership-screen-membership-container ur-wallet">
            <div className="header-title">
              UR <span style={{ color: "#FF6B35" }}>Wallet</span>
            </div>
            <div className="divider"></div>
            <div
              className={`membership-screen-my-membership-container ${userProfileData?.credit?.membership?.membership_type}`}
              onClick={handleURMembershipCardClick}
            >
              <div className="sub-container">
                <span
                  style={{
                    color: `${userProfileData?.credit?.membership?.membership_level === 3 ? "black" : "white"}`,
                  }}
                >
                  Everything Ur Wallet Card gets you{" "}
                </span>
                <div className="right-container">
                  <span>
                    {userProfileData?.credit?.credit_balance > 1
                      ? "Credits"
                      : "Credit"}{" "}
                    : {userProfileData?.credit?.credit_balance}
                  </span>{" "}
                  <button>
                    <img src={rightArrow} alt="right-arrow" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

      <div className="membership-screen-background-container">
        <div className="membership-screen-tab-bar-background-container">
          <div className="membership-screen-tab-bar-container">
            {MEMBERSHIP_FOUNDER_TYPES?.map((type: any, index: number) => (
              <div
                key={index}
                className={`membership-screen-tab-bar-item-container ${
                  selectedTab === type.value && "selected"
                }`}
                onClick={() => {
                  if (type.value === MEMBERSHIP_FOUNDER_TYPE.WELLNESS) {
                    navigate(ROUTE_PATHS.WSM_WEB_LINK_DETAIL, {
                      state: {
                        anyData: {
                          title: "Wellness",
                          url: WEB_LINK.WELNESS_LINK,
                        },
                      },
                    });
                  } else {
                    setSelectedTab(type.value);
                  }
                }}
              >
                {type.name}
              </div>
            ))}
          </div>
        </div>

        {approvedMembership && !userProfileData?.credit?.membership && (
          <div className="membership-screen-container">
            <div className="membership-screen-membership-container">
              <div className="header-title">
                ONE MEMBERSHIP 5 SPACES 10x GROWTH
              </div>
              <div className="header-box-container">
                For Ambitious Professionals Only
              </div>
              <div className="divider"></div>
              <div className="membership-screen-approved-membership-container">
                <div className="membership-screen-approved-membership-header-banner">
                  <img src={infoIcon} alt="info-icon" />
                  <span>
                    <span style={{ color: "#C1F700" }}>
                      Membership Approved — Just Activate It!
                    </span>{" "}
                    <span style={{ color: "#ff6b35" }}>
                      Complete your payment to
                    </span>{" "}
                    unlock your SabeHub Journey.
                  </span>
                </div>
                <div className="membership-screen-approved-membership-sub-container">
                  <div
                    className="image-text-container"
                    onClick={() =>
                      handleMembershipCardClick(approvedMembership)
                    }
                  >
                    <img
                      className="card-image"
                      src={getMembershipCardImage(
                        approvedMembership?.membership_type,
                      )}
                      alt="membership-card"
                    />
                    <div className="custom-text-overlay"></div>
                  </div>
                  <div className="right-container">
                    {approvedMembership?.discription && (
                      <div className="detail-container">
                        {approvedMembership?.discription}
                      </div>
                    )}
                    {approvedMembership?.title && (
                      <div className="detail-container">
                        {approvedMembership?.title}
                      </div>
                    )}
                    <button
                      onClick={() =>
                        handleMembershipCardClick(approvedMembership)
                      }
                    >
                      Pay Now
                      <img src={rightArrow} alt="right-arrow" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {passesData?.data?.content?.length > 0 && (
          <div className="membership-screen-credit-container">
            <div className="header">
              Pass<span style={{ color: "#FF6B35" }}>es</span>
            </div>
            <div className="divider"></div>
            <div className="membership-screen-credit-sub-container">
              {passesData?.data?.content?.map((pass: any, index: number) => {
                return (
                  <div
                    key={index}
                    className="membership-screen-passes-container-cell"
                    onClick={() => handlePassCardClick(pass)}
                  >
                    <div className="membership-screen-passes-content-container">
                      <div className="header-container">
                        <div
                          className="image-container"
                          style={{
                            backgroundImage: `url(${getMembershipPassesIcon(
                              index,
                            )})`,
                            backgroundColor: "black",
                            backgroundSize: "80% 80%",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                          }}
                        ></div>

                        <div className="content_container">
                          <div className="text-container">
                            <span lang="en">
                              {highlightLastWord(pass.title ?? "")}
                            </span>
                          </div>
                          {pass?.is_recommended && (
                            <div className="recomended_container">
                              Recommended
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="divider"></div>
                      <div className="footer-container">
                        {/* <div className="left-container">
                          <img src={clockIcon} alt="clock-icon" />
                          <span>{pass.duration}</span>
                        </div> */}
                        <span>
                          {CALENDAR_RESERVATION_TABS.find(
                            (type) => type.value === pass?.service_type,
                          )?.name || ""}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {filteredMembershipList?.length > 0 && (
          <div className="membership-screen-container">
            <div className="membership-screen-membership-container">
              <div className="header-title">
                Membership <span style={{ color: "#FF6B35" }}>CARDS</span>
              </div>
              <div className="divider"></div>
              {filteredMembershipList?.map((membership: any, index: number) => (
                <div>
                  <div
                    key={index}
                    className={`membership-screen-card-container ${
                      userProfileData?.credit?.membership?.membership_type ===
                      membership?.membership_type
                        ? "active-container"
                        : "non-active-container"
                    }`}
                  >
                    <div
                      className="image-text-container"
                      onClick={() => handleMembershipCardClick(membership)}
                    >
                      <img
                        className={`membership-card-image active-shadow`}
                        src={getMembershipCardImage(
                          membership?.membership_type,
                        )}
                        alt="membership-card"
                      />
                    </div>
                    <div className="right-container">
                      {membership?.title && (
                        <div className="detail-container">
                          {membership?.title}
                        </div>
                      )}
                      <div
                        className="button-container"
                        style={{
                          backgroundImage: `url(${
                            userProfileData?.credit?.membership
                              ?.membership_type ===
                              membership?.membership_type && activeTagIcon
                          })`,
                        }}
                      >
                        <button
                          onClick={() => handleMembershipCardClick(membership)}
                        >
                          {membership?.cta_text
                            ? membership?.cta_text
                            : MEMBERSHIP_TYPE.find(
                                (type) =>
                                  type.value === membership?.membership_type,
                              )?.name}
                          <img src={rightArrow} alt="right-arrow" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {creditPlanListData?.data?.content?.length > 0 && isActiveMember && (
        <div className="membership-screen-credit-container">
          <div className="header">
            Top up <span style={{ color: "#FF6B35" }}>CREDITS</span>
          </div>
          <div className="divider"></div>
          <div className="membership-screen-credit-sub-container">
            {creditPlanListData?.data?.content?.map(
              (creditPlan: any, index: number) => {
                return (
                  <div
                    key={index}
                    className="membership-screen-credit-container-cell"
                    onClick={() => handleCreditPlanCardClick(creditPlan)}
                  >
                    <div className="header-container">
                      <span>{creditPlan?.title}</span>
                    </div>
                    <div className="credit-number-container">
                      {creditPlan?.total_credits}{" "}
                      <span>
                        {creditPlan?.total_credits > 1 ? "Credits" : "Credit"}
                      </span>
                    </div>
                    <div className="credit-price-container">
                      ₹ {creditPlan?.credit_price?.toLocaleString("en-US")}
                    </div>
                    <div className="button-container">
                      <img src={rightOrangeIcon} alt="right-button" />
                    </div>
                  </div>
                );
              },
            )}
          </div>
        </div>
      )}

      {/* {!passesListError &&
          passesListData?.data?.content?.map((passData: any, index: number) => (
            <div
              className="membership-screen-one-day-pass-container"
              style={{
                backgroundImage: `url(${cardSecondImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="membership-screen-one-day-pass-sub-container">
                <div className="title">{passData?.title}</div>
                <div className="sub-title">
                  {passData?.pass_days} Full Day Access
                </div>
                <div className="btn-container">
                  <button onClick={() => handleFullDayPassClick(passData)}>
                    Explore
                  </button>
                </div>
              </div>
            </div>
          ))} */}

      <MembershipInviteOnlyDialog
        profileStatus={userProfileData?.credit?.status}
        open={showInviteOnlyDialog}
        onClose={() => setShowInviteOnlyDialog(false)}
      />
      <CreditPlanDialog
        planData={selectedCreditPlan}
        open={showCreditPlanDialog}
        onClose={() => setShowCreditPlanDialog(false)}
      />
    </div>
  );
};

export default MembershipScreen;
